import { FC, Fragment, useContext, useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { ActionDashboardActionType, ActionDashboardStateActions, NotTreatedData, PendingCompProps } from "./types";
import { PENDING_MANUFACTURE_TABLE, PENDING_TABLE } from "src/constants/todos";
import { format } from "date-fns";
import { AuthContext } from "src/context/authContext";
import { ActionStatisticsDashboardActionType, PatientFilterStateActions } from "../manufacturer/actionDashboard/types";
import RequestDateOfTreatment from "src/components/modals/requestDateOfTreatment";
import CancelTreatment from "src/components/modals/cancelTreatment";
import ConfirmIndication from "src/components/modals/confirmIndication";
import { ToastContext } from "src/context/toastContext";
import { LoaderContext } from "src/context/loaderContext";
import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import { ToastTypes } from "src/types";
import useCaseTransferFunc from "src/hooks/useCaseTransferFunc";
import AddNote from "src/components/modals/addNote";
import ReRunPatientModal from "src/components/modals/rerunPatientModal";
import UploadClinicalModal from "src/components/modals/transferCaseDialogs/uploadClinicalModal";
import TransferCaseModal from "src/components/modals/transferCaseDialogs/transferCaseModal";
import TransferNotNowModal from "src/components/modals/transferCaseDialogs/transferNotNowModal";
import { handleNavigation } from "src/helpers";
import PracticeContactInfo from "src/components/practiceContactInfo";
import { ColumnSortProps } from "src/components/tableHeader/types";
import TableHeader from "src/components/tableHeader";
import { sortTableColumns } from "src/helpers/stats";


const PendingTable: FC<PendingCompProps> = ({ tableData, currentPage, onPageChange, onActionPerformed }): JSX.Element => {
  const { isManufacturer, defaultView, userData } = useContext(AuthContext);
  const location = useLocation();

  const [notTreatedListing, updateNotTreatedListing] = useState<NotTreatedData[]>([]);
  const [sortingConfig, setSortingConfig] = useState<ColumnSortProps>({
    sort_by: '',
    direction: 'desc',
  });

  const [saveNoteModal, setDataforNoteModal] = useState<{ isModalVisible: boolean; caseId: number; }>({
    isModalVisible: false,
    caseId: 0,
  });
  const [showCancelIndicationModal, setDataForCancelIndication] = useState<{ isModalVisible: boolean; caseId: number; prescriptionId: number }>({
    isModalVisible: false,
    caseId: 0,
    prescriptionId: 0
  });
  const [showRequestTreatmentModal, setDataForRequestModalTreatment] = useState<{ isModalVisible: boolean; caseId: number; prescriptionId: number; bentype: string; investigated_at?: string }>({
    isModalVisible: false,
    caseId: 0,
    prescriptionId: 0,
    bentype: "",
    investigated_at: ""
  });
  const [cancelTreatmentModal, setDataForCancelModal] = useState<{ isModalVisible: boolean; caseId: number; prescriptionId: number }>({
    isModalVisible: false,
    caseId: 0,
    prescriptionId: 0
  });
  const [showReRunPatientModal, setShowReRunPatientModal] = useState<{ isModalVisible: boolean; caseId: number; prescriptionId: number, title: string, bentype: string; investigated_at?: string; }>({
    isModalVisible: false,
    caseId: 0,
    prescriptionId: 0,
    title: '',
    bentype: ""
  });
  const [precertInfoModal, setPrecertInfoModal] = useState<{ isModalVisible: boolean; caseId: number; precertId: number; }>({
    isModalVisible: false,
    caseId: 0,
    precertId: 0,
  })
  const [transferCaseModal, setTransferCaseModal] = useState<{ isModalVisible: boolean; caseId: number; precertId: number; }>({
    isModalVisible: false,
    caseId: 0,
    precertId: 0,
  })
  const [transferCaseNotnowModal, setTransferCaseNotnowModal] = useState<boolean>(false)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [rowindex, setIndex] = useState<number>();
  const [pageSearch, setPageSearch] = useState(currentPage.toString());


  const changePageNumber = (page: { selected: number }) => {
    if (isManufacturer) {
      const action: ActionStatisticsDashboardActionType = {
        type: PatientFilterStateActions.CHANGE_NOT_TREATED_PAGE,
        payload: page.selected + 1,
      };
      onPageChange(action as never);

    } else {
      const action: ActionDashboardActionType = {
        type: ActionDashboardStateActions.CHANGE_NOT_TREATED_PAGE,
        payload: page.selected + 1,
      };
      onPageChange(action as never);
    }
    setPageSearch((page.selected + 1).toString())


  };
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);

  useEffect(() => {
    updateNotTreatedListing(tableData?.not_treateds_data ?? [])
    if (tableData?.not_treateds_data) {
      setSortingConfig({ direction: "desc", sort_by: "" })
    }
  }, [tableData])


  const { data: transferRxData, mutate: transferRxByCaseId } =
    useFetch(APIEndpoints.TRANSFER_RX,);

  useEffect(() => {
    if (transferRxData) {
      hideLoader()
      const { message } = transferRxData as unknown as { code: number; message: string; };
      showToast([message], ToastTypes.SUCCESS);
      onActionPerformed();
      // getCaseListing();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transferRxData]);

  // useEffect(() => {
  //   if (transferRxLoading) setLoader();
  //   else hideLoader();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [transferRxLoading]);

  const ConfirmAlert = (title: string, buttonName: string, caseId: number) => {

    const result = window.confirm(title);
    if (result) {
      setLoader()
      // if(buttonName === 'xFerToSP'){
      transferRxByCaseId({}, { case_id: caseId }, { rep_xfer: true })
      // }
      // else if (buttonName === "patientPurchase"){
      //   transferRxByCaseId({case_id:caseId,pdp:1},{case_id:caseId,pdp:1})
      // }
    }
  };

  const navigate = useNavigate();
  const { apiInPorgress: transferAPILoading, submitTransferCase } = useCaseTransferFunc({ redirectAction: onActionPerformed });

  // const navigateToPrecertPage = (data: any) => {
  //   const { active_precert_id, bi_case_id } = data;
  //   //console.log("Data.......",data,active_precert_id, bi_case_id);
  //   navigate(`/cases/${bi_case_id}/precerts/${active_precert_id}/edit`);
  // }

  const transferCase = (msg: string, caseId: number, transfer: boolean, pa_workflow_required?: boolean, active_precert_id?: number) => {
    // eslint-disable-next-line no-restricted-globals
    // const res = confirm(msg);
    // if (res) submitTransferCase(caseId,transfer)
    // if (pa_workflow_required ) setPrecertInfoModal({ isModalVisible: true, caseId: caseId, precertId: active_precert_id || 0 })
    // else {
    // eslint-disable-next-line no-restricted-globals
    const res = confirm(msg);
    if (res) submitTransferCase(caseId, transfer)
    // }
  }

  const navigateToModalAndPage = (item: NotTreatedData) => {
    if (item.re_run_type === 'popup') {
      setShowReRunPatientModal({ caseId: item.bi_case_id, isModalVisible: true, prescriptionId: item.prescription_id, title: "Please update case status below", bentype: "med", investigated_at: item.investigated_at ?? undefined })
    } else {
      navigate(`/cases/${item ? item.bi_case_id : 0}/clone`)
    }
  }
  const handlePageSearch = () => {
    const pageNumber = Number(pageSearch);

    if (!tableData?.page_count) return;

    if (!pageNumber || pageNumber < 1 || pageNumber > tableData.page_count) {
      // optionally reset input to current page
      setPageSearch(currentPage.toString());
      return;
    }

    // Trigger page change
    changePageNumber({ selected: pageNumber - 1 });

    // Update input to formatted value
    setPageSearch(pageNumber.toString());
  };

  const redirectDecision = () => {
    const isRedirectRequired = handleNavigation(defaultView, location.pathname);
    if (isRedirectRequired) {
      navigate(defaultView.includes("/") ? defaultView : `/${defaultView}`, { replace: true })
    } else {
      navigate(0)
    }
  }

  const changeIdOrder = (value: string) => {
    sortTableColumns(value, sortingConfig, setSortingConfig, notTreatedListing, updateNotTreatedListing)
  };

  return (
    <Fragment>
      <div className="table-responsive overflow-auto" style={{ maxHeight: "600px" }}>
        <table className="table table-striped table-sm mb-0">
          <thead className="sticky-top" style={{ zIndex: '500' }}>
            <tr className="text-center align-items-center">
              {isManufacturer  === false  ?
               (PENDING_TABLE.map((tableHeader, index) => (
                  <TableHeader
                    key={index}
                    classNames={`bg-secondary-subtle ${index === 8 || index === 9 ? 'border border-2 border-top-0 border-bottom-0 border-dark' : ''}`}
                    tableHeader={{
                      ...tableHeader,
                      width: `${tableHeader.width}%`
                    }}
                    sortConfig={sortingConfig}
                    changeIdOrder={changeIdOrder}
                  />
                )))
                :
                 (PENDING_MANUFACTURE_TABLE.map((tableHeader, index) => (
                  (tableHeader.label === "FAM/Office Note" && userData && userData.ref_type === "rep") ?
                    <></>
                    :
                    <TableHeader
                      key={index}
                      classNames={`bg-secondary-subtle ${index === 8 || index === 9 || index === 10 ? 'border border-2 border-end-0 border-top-0 border-bottom-0 border-start border-dark' : ''}`}
                      tableHeader={{
                        ...tableHeader,
                        width: `${tableHeader.width}%`
                      }}
                      sortConfig={sortingConfig}
                      changeIdOrder={changeIdOrder}
                    />
                )))}
            </tr>
          </thead>

          <tbody>
            {notTreatedListing.length > 0 ?
              notTreatedListing.map((data, index) => {
                const isOffice = data.kam_fam_notes?.type.toLowerCase().replace(/note/g, '').trim() === "office"
                const isFam = data.kam_fam_notes?.type.toLowerCase().replace(/note/g, '').trim() === "fam"
                return(
                <tr key={index}>
                  {data.patient_name !== 'Redacted' ?
                    <td className="text-center align-middle fs-6">
                      <Link
                        className="btn btn-link link-offset-0 link-offset-0-hover link-underline link-underline-opacity-0 link-underline-opacity-100-hover p-0 align-baseline user-select-text"
                        to={`/global_patients/${data.patient_id}/edit`}
                      >
                        {data.patient_name}
                      </Link>

                    </td>
                    :
                    (
                      <td className="text-black text-center align-middle fs-6 user-select-text">
                        {data.patient_name}
                      </td>
                    )
                  }
                  <td className="text-center align-middle fs-6">
                    <Link
                      to={`/global_patients/${data.patient_id}/edit`}
                      className="btn btn-link link-offset-0 link-offset-0-hover link-underline link-underline-opacity-0 link-underline-opacity-100-hover p-0 align-baseline user-select-text"
                    >
                      <span className="user-select-text">{data.patient_id}</span>
                    </Link>
                  </td>
                  <td className="text-center align-middle fs-6">
                    {isManufacturer ? (
                      data.indication.toLowerCase() === "other" ?
                        <p className="fw-bold text-danger mb-0">{data.bi_case_id}</p> :
                        <Link
                          to={`/cases/${data.bi_case_id}`}
                          className="btn btn-link link-offset-0 link-offset-0-hover link-underline link-underline-opacity-0 link-underline-opacity-100-hover p-0 align-baseline user-select-text"
                        >
                          <span className="d-inline-flex align-items-center">{data.message_icon && !isManufacturer && <i className="fas fa-comment me-1"></i>}{data.bi_case_id}</span>
                        </Link>
                    ) : (
                      <Link
                        to={`/cases/${data.bi_case_id}`}
                        className="btn btn-link link-offset-0 link-offset-0-hover link-underline link-underline-opacity-0 link-underline-opacity-100-hover p-0 align-baseline user-select-text"
                      >
                        <span className="d-inline-flex align-items-center">{data.message_icon && !isManufacturer && <i className="fas fa-comment me-1"></i>}{data.bi_case_id}</span>
                      </Link>
                    )}
                  </td>
                  <td className="text-center align-middle fs-6">
                    {isManufacturer ? (
                      typeof data.case_type === "string" && data.case_type ? (
                        <button type="button" className={`btn btn-sm ${data.case_type.toLowerCase() === "new" ? "background-color-2 text-white fw-bold btn-new user-select-text" : "btn-green btn-new user-select-text"}`}>
                          {data.case_type}
                        </button>
                      ) : null
                    ) : (
                      typeof data.reverification === "string" && data.reverification ? (
                        <button type="button" className={`btn btn-sm ${data.reverification.toLowerCase() === "new" ? "background-color-2 text-white fw-bold btn-new user-select-text" : "btn-green btn-new user-select-text"}`}>
                          {data.reverification}
                        </button>
                      ) : null
                    )}
                  </td>
                  <td className="text-center align-middle fs-6">
                    {data.bi_submitted && format(data.bi_submitted, "MM/dd/yyyy")}
                  </td>
                  <td className="text-center align-middle fs-6">
                    {data.bi_completed && format(data.bi_completed, "MM/dd/yyyy")}
                  </td>
                  <td className="text-center align-middle fs-6">
                    {isManufacturer ? data.payer : data.insurance_type}
                  </td>
                  <td className="text-center align-middle fs-6">
                    <PracticeContactInfo
                      name={data.practice_name} 
                      address={data.practice_full_address} 
                      phone={data.practice_phone_number ?? ""} 
                      fax={data.practice_fax_number ?? ""}
                      indexKey={index}
                    >
                      <>{data.provider}</>
                    </PracticeContactInfo>
                  </td>
                  <td
                    className={`text-center ${data.medical_coverage_status_color !== 5 ? "text-white" : ""} align-middle fs-6 status-borders fw-bold background-color-${data.medical_coverage_status_color}`}
                    title={data.medical_coverage_tooltip}
                    data-bs-toggle="tooltip"
                  >
                    {data.medical_coverage_status}
                  </td>
                  <td
                    className={`text-center ${data.pharmacy_coverage_status_color !== 5 ? "text-white" : ""} align-middle fs-6 status-borders fw-bold background-color-${data.pharmacy_coverage_status_color}`}
                    title={data.pharmacy_coverage_tooltip}
                    data-bs-toggle="tooltip"
                  >
                    {data.pharmacy_coverage_status}
                  </td>
                  {isManufacturer ?
                    (<td className={`text-center text-light align-middle fs-6`} id="next-steps">
                      {data.indication.toLowerCase() === "other" ? <span className="text-black">No Action Available</span> : null}
                      {data && data['next_steps'] && data.indication.toLowerCase() !== "other" && data['next_steps'].map((step, index) => {
                        // {data?.medical_next_steps?.map((step, index) => {
                        if (step === "Treated") {
                          return (
                            <button key={index} className="btn btn-green rounded-0 m-1 btn-sm"
                              onClick={() => setDataForRequestModalTreatment({ isModalVisible: true, caseId: data.bi_case_id, prescriptionId: data.prescription_id, bentype: "med", investigated_at: data.investigated_at || "" })}

                              type="button">

                              <i className="far fa-clipboard"></i> Treated
                            </button>
                          );
                        } else if (step === "Not Treating") {
                          return (
                            <button key={index} className="btn btn-green rounded-0 m-1 btn-sm"
                              onClick={() => setDataForCancelModal({ isModalVisible: true, caseId: data.bi_case_id, prescriptionId: data.prescription_id })}

                              type="button">
                              <i className="fas fa-times"></i> Not Treated
                            </button>
                          );
                        } else if (step === "Not Treated") {
                          return (
                            <button key={index} className="btn btn-green btn-sm rounded-0 m-1"
                              onClick={() => setDataForCancelModal({ isModalVisible: true, caseId: data.bi_case_id, prescriptionId: data.prescription_id })}

                              type="button">
                              <i className="fas fa-times"></i> Not Treated
                            </button>
                          );
                        } else if (step === "Transferred") {
                          return (
                            <button key={index} className="btn btn-green btn-sm rounded-0 m-1"
                              onClick={() => ConfirmAlert('By clicking this you are noting the office has transferred this prescription to a Specialty Pharmacy. Are you sure you want to mark this prescription transferred? This cannot be undone!', "xFerToSP", data.bi_case_id)}
                              type="button">
                              <i className="fas fa-prescription"></i> Transferred
                            </button>
                          );
                        } else if (step === "Treatment Scheduled") {
                          return (
                            <button key={index} className="btn btn-green btn-sm background-color-3 rounded-0 m-1"
                              onClick={() => setDataForRequestModalTreatment({ isModalVisible: true, caseId: data.bi_case_id, prescriptionId: data.prescription_id, bentype: "sd" })}
                              type="button">

                              <i className="fas fa-times"></i> Treatment Scheduled
                            </button>
                          );
                        } else if (step.includes("Scheduled Tx Date")) {
                          return (
                            <button key={index} className="btn btn-link m-1 user-select-text"
                              onClick={() => setDataForRequestModalTreatment({ isModalVisible: true, caseId: data.bi_case_id, prescriptionId: data.prescription_id, bentype: "sd" })}
                              type="button">

                              {step}
                            </button>
                          );
                        } else {
                          return (
                            <p className="text-black">No Action Available</p>
                          );
                        }
                      })
                      }

                    </td>)
                    :
                    (
                      <td className={`text-center text-light align-middle fs-6 border border-1 border-end-0 border-top-0 border-bottom-0 border-start border-dark`} id="next-steps">
                        {data && data['next_steps']?.map((step, index) => {
                          //{data && data['next_steps'].map((step, index) => {

                          // switch (step) {
                          if (step === "Treated") {
                            return (
                              <button key={index} className="btn btn-green btn-sm rounded-0 m-1" type="button"
                                onClick={() => setDataForRequestModalTreatment({ isModalVisible: true, caseId: data.bi_case_id, prescriptionId: data.prescription_id, bentype: "na", investigated_at: data.investigated_at || "" })}
                              >
                                <i className="far fa-clipboard"></i> Treated
                              </button>
                            );
                          }

                          else if (step === "Treatment Scheduled") {
                            return (
                              <button key={index} className="btn btn-green btn-sm background-color-3 rounded-0 m-1"
                                onClick={() => setDataForRequestModalTreatment({ isModalVisible: true, caseId: data.bi_case_id, prescriptionId: data.prescription_id, bentype: "sd" })}
                                type="button">

                                <i className="fas fa-times"></i> Treatment Scheduled
                              </button>
                            );
                          }

                          else if (step === "Not Treated" || step === "Not Treating") {
                            return (
                              <button key={index} onClick={() => setDataForCancelModal({ caseId: data.bi_case_id, isModalVisible: true, prescriptionId: data?.prescription_id })} className="btn btn-green btn-sm rounded-0 m-1" type="button">
                                <i className="fas fa-times"></i> Not Treating
                              </button>
                            );
                          }

                          else if (step === "Precert") {
                            return <></>
                            // return (
                            //   <button
                            //     key={index}
                            //     className="btn background-color-5 border border-1 border-secondary border-opacity-75 rounded-0 m-1"
                            //     type="button"
                            //     onClick={() => showToast(["Precert not found!"], ToastTypes.ERROR)}
                            //   >
                            //     <i className="bi bi-clipboard"></i> Precert
                            //   </button>
                            // );

                          }
                          // else if (step === "Review") {
                          //   return (
                          //     <button
                          //       key={index}
                          //       className="btn background-color-2 rounded-0 m-1"
                          //       type="button"
                          //       onClick={() => navigate(`/cases/${data.bi_case_id}/precerts/${data.pending_precert_id}/review`)}
                          //     >
                          //       <i className="bi bi-clipboard"></i> Review
                          //     </button>
                          //   );

                          // } else if (step === "Appeal") {
                          //   return (
                          //     <button
                          //       key={index}
                          //       className="btn btn-green background-color-3 rounded-0 m-1"
                          //       type="button"
                          //       onClick={() => submiAppealForCase(data.bi_case_id, data.appeal_precert_id || 0)}
                          //       disabled={apiInPorgress}
                          //     >
                          //       <i className="bi bi-clipboard"></i> Appeal
                          //     </button>
                          //   );

                          // } 
                          else if (step === "Transfer to Alliance Rx Walgreens") {
                            return (
                              <button
                                key={index}
                                className="btn btn-green btn-sm background-color-2 rounded-0 m-1"
                                type="button"
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title="Clicking this button will transfer the prescription through the Specialty Pharmacy Channel"
                                onClick={() =>
                                  transferCase(
                                    "Are you sure you want to transfer this prescription? This cannot be undone!",
                                    data.bi_case_id, true, data.pa_workflow_required, data.active_precert_id
                                  )
                                }
                                disabled={transferAPILoading}
                              >
                                <i className="fas fa-prescription"></i> Transfer to Alliance Rx Walgreens
                              </button>
                            );

                          }
                          else if (step === "Transferred to other Specialty Pharmacy") {
                            return (
                              <button
                                key={index}
                                className="btn btn-green background-color-2 rounded-0 m-1"
                                type="button"
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title="Clicking this button indicates your office has already transferred this case to a local pharmacy"
                                onClick={() =>
                                  transferCase(
                                    "ALERT: Clicking this button indicates your office has already transferred this case to a local pharmacy outside of MQC. Your office will be responsible for any PA requirements as well as follow up with that pharmacy",
                                    data.bi_case_id, true, data.pa_workflow_required, data.active_precert_id
                                  )
                                }
                                disabled={transferAPILoading}
                              >
                                <i className="bi bi-prescription"></i> Transferred to other Specialty Pharmacy
                              </button>
                            );

                          } else if (step === "Transfer to CenterWell") {
                            return (
                              <button
                                key={index}
                                className="btn btn-green background-color-2 rounded-0 m-1"
                                type="button"
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title="Clicking this button will transfer the prescription through the Specialty Pharmacy Channel"
                                onClick={() => {
                                  if (data.pa_workflow_required) {
                                    setTransferCaseModal({ isModalVisible: true, caseId: data.bi_case_id, precertId: 0 })
                                  } else {
                                    transferCase(
                                      "Are you sure you want to transfer this prescription? This cannot be undone!",
                                      data.bi_case_id, true, data.pa_workflow_required, data.active_precert_id
                                    )
                                  }
                                }}
                                disabled={transferAPILoading}
                              >
                                <i className="bi bi-prescription"></i> Transfer to CenterWell
                              </button>
                            );

                          } else if (step === "Transfer to Knipper") {
                            return (
                              <button
                                key={index}
                                className="btn btn-green background-color-2 rounded-0 m-1"
                                type="button"
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title="Clicking this button will transfer the prescription through the Specialty Pharmacy Channel"
                                onClick={() =>
                                  transferCase(
                                    "Are you sure you want to transfer this prescription? This cannot be undone!",
                                    data.bi_case_id, true, data.pa_workflow_required, data.active_precert_id
                                  )
                                }
                                disabled={transferAPILoading}
                              >
                                <i className="bi bi-prescription"></i> Transfer to Knipper
                              </button>
                            );

                          }
                          // else if (step === "No Action Required") {
                          //   return (
                          //     <p className="text-black">No Action Required</p>
                          //   );

                          // }
                          else if (step.includes("Scheduled Tx Date")) {
                            return (
                              <button key={index} className="btn btn-link m-1"
                                onClick={() => setDataForRequestModalTreatment({ isModalVisible: true, caseId: data.bi_case_id, prescriptionId: data.prescription_id, bentype: "sd" })}
                                type="button">

                                {step}
                              </button>
                            );

                          }
                          else if (["review", "appeal"].includes(step.toLowerCase())) {
                            return (<></>);
                          } else {
                            return (<span key={index} className="text-black">{step}</span>);
                          }
                        }
                        )
                        }
                      </td>
                    )
                  }

                  {data && data.next_steps && data.next_steps.length > 0 &&
                    data.next_steps.map((step, index) => {
                      // if (step.match(/\d{2}\/\d{2}\/\d{4}/)) {
                      //   return (<button key={index} className="btn m-1"
                      //     onClick={() => setDataForRequestModalTreatment({ isModalVisible: true, caseId: data.bi_case_id, prescriptionId: data.prescription_id, bentype: "non" })}
                      //     type="button">
                      //     <i className="bi bi-x-lg"></i> {step}
                      //   </button>)
                      // } else 
                      if (step === "Schedule") {
                        return (
                          <button key={index} className="btn btn-green btn-sm background-color-3 rounded-0 m-1"
                            onClick={() => setDataForRequestModalTreatment({ isModalVisible: true, caseId: data.bi_case_id, prescriptionId: data.prescription_id, bentype: "non" })}
                            type="button">

                            <i className="bi bi-x-lg"></i> Schedule
                          </button>
                        );
                      } else return null;
                    })
                  }
                  {!isManufacturer &&
                   <> <td style={{ minWidth: '115px' }}>
                      <span className="btn btn-green my-2 rounded-0" onClick={() => navigateToModalAndPage(data)}>
                        <i className="fas fa-sync-alt"></i> Re-run
                      </span>
                    </td>
                    <td className="align-middle text-center fs-6" style={{ minWidth: '105px' }}>
                        {data.kam_fam_notes?.clickable && data.kam_fam_notes.text ? (
                          data.kam_fam_notes.text === 'Add Note' ? (
                            <button
                              type="button"
                              className="btn btn-green btn-sm rounded-0"
                              onClick={() =>
                                setDataforNoteModal({ isModalVisible: true, caseId: data.bi_case_id })
                              }
                            >
                              <i className="fas fa-times me-1"></i>
                              {data.kam_fam_notes.text}
                            </button>
                          ) : data.kam_fam_notes.text === 'Confirm Indication' ? (
                            <button
                              type="button"
                              className="btn btn-green btn-sm rounded-0"
                              onClick={() =>
                                setDataforNoteModal({ isModalVisible: true, caseId: data.bi_case_id })
                              }
                            >
                              <i className="fas fa-times me-1"></i>
                              {"Add Note"}
                            </button>
                          ) : 
                          // (!(String(data?.kam_fam_notes?.text ?? "").includes("No FAM Action Needed")) && !isManufacturer) ? (
                          //   <button
                          //     className={`btn btn-link ${isOffice ? "btn-office" : isFam ? "btn-fam" : ""}`}
                          //     onClick={() =>
                          //       setDataforNoteModal({ isModalVisible: true, caseId: data.bi_case_id })
                          //     }
                          //   >
                          //     {data.kam_fam_notes.text}
                          //   </button>
                          // ):(<button
                          //   type="button"
                          //   className="btn btn-green btn-sm rounded-0"
                          //   onClick={() =>
                          //     setDataforNoteModal({ isModalVisible: true, caseId: data.bi_case_id })
                          //   }
                          // >
                          //   <i className="fas fa-times me-1"></i> Add Note
                          // </button>)
                          (isManufacturer || !String(data.kam_fam_notes?.text).includes("No FAM Action Needed"))
                                  ? (
                                    <button
                                      className={`btn btn-link ${isOffice ? "btn-office" : isFam ? "btn-fam" : ""} user-select-text`}
                                      onClick={() =>
                                        setDataforNoteModal({
                                          isModalVisible: true,
                                          caseId: data.bi_case_id
                                        })
                                      }
                                    >
                                      {data.kam_fam_notes?.text}
                                    </button>
                                  ) : (
                                    <button
                                      type="button"
                                      className="btn btn-green btn-sm rounded-0"
                                      onClick={() =>
                                        setDataforNoteModal({
                                          isModalVisible: true,
                                          caseId: data.bi_case_id
                                        })
                                      }
                                    >
                                      <i className="fas fa-times me-1"></i> Add Note
                                    </button>
                                  )
                        ) : (
                          // 'N/A'
                          <button
                              type="button"
                              className="btn btn-green btn-sm rounded-0"
                              onClick={() =>
                                setDataforNoteModal({ isModalVisible: true, caseId: data.bi_case_id })
                              }
                            >
                              <i className="fas fa-times me-1"></i>
                              {"Add Note"}
                            </button>
                        )}
                      </td>
                      </>
                  }
                  {isManufacturer && (
                    <>
                      <td className="align-middle text-center fs-6">
                        {data.pcc}
                      </td>
                      <td className="align-middle text-center fs-6">
                        {data.qns}
                      </td>
                      <td className="text-center align-middle fs-6">
                        {data.indication || 'N/A'}
                      </td>
                      {/* <td className="text-center align-middle fs-6">
                        {data.confirm_indication.clickable ?
                          <button
                            type="button" className="btn btn-success btn-sm rounded-0"
                            onClick={() => setDataForCancelIndication({ isModalVisible: true, caseId: data.bi_case_id, prescriptionId: data.prescription_id })}
                          >
                            Confirm Indication
                          </button>
                          :
                          <p>{data.confirm_indication.text || "N/A"}</p>
                        }
                      </td> */}
                      {userData?.ref_type !== "rep" &&
                        <td className="align-middle text-center fs-6" style={{ minWidth: '105px' }}>
                          {data.kam_fam_notes?.clickable && data.kam_fam_notes.text ? (
                            data.kam_fam_notes.text === 'Add Note' ? (
                              <button
                                type="button"
                                className="btn btn-green btn-sm rounded-0"
                                onClick={() =>
                                  setDataforNoteModal({ isModalVisible: true, caseId: data.bi_case_id })
                                }
                              >
                                <i className="fas fa-times me-1"></i>
                                {data.kam_fam_notes.text}
                              </button>
                            ) : data.kam_fam_notes.text === 'Confirm Indication' ? (
                              <button
                                type="button"
                                className="btn btn-green btn-sm rounded-0"
                                onClick={() =>
                                  setDataForCancelIndication({
                                    isModalVisible: true,
                                    caseId: data.bi_case_id,
                                    prescriptionId: data.prescription_id,
                                  })
                                }
                              >
                                Confirm Indication
                              </button>
                            ) : (
                              <button
                                className={`btn btn-link ${isOffice ? "btn-office" : isFam ? "btn-fam" : ""} user-select-text`}
                                onClick={() =>
                                  setDataforNoteModal({ isModalVisible: true, caseId: data.bi_case_id })
                                }
                              >
                                {data.kam_fam_notes.text}
                              </button>
                            )
                          ) : (
                            'N/A'
                          )}
                        </td>}
                    </>
                  )}
                </tr> 
                )
              })
              : null}
          </tbody>
        </table>
      </div>

      {isManufacturer && (tableData && tableData.page_count && tableData.page_count > 1 ? (
        <div className="pagination pagination-sm pagination-lg justify-content-center flex-wrap mt-3">
          {currentPage !== 1 ? (
            <li className="page-data">
              <button className="btn btn-link page-link rounded-0" onClick={() => changePageNumber({ selected: 0 })}>
                <i className="bi bi-chevron-double-left"></i> First
              </button>
            </li>
          ) : null}

          <ReactPaginate
            nextLabel={<>Next <i className="bi bi-chevron-right"></i></>}
            onPageChange={changePageNumber}
            pageRangeDisplayed={3}
            marginPagesDisplayed={2}
            pageCount={tableData.page_count}
            previousLabel={<><i className="bi bi-chevron-left"></i> Previous</>}
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-data"
            previousLinkClassName="page-link rounded-0"
            nextClassName="page-data"
            nextLinkClassName="page-link rounded-0"
            breakLabel="..."
            breakClassName="page-data"
            breakLinkClassName="page-link"
            containerClassName="pagination pagination-sm pagination-lg"
            activeClassName="active"
            renderOnZeroPageCount={null}
            forcePage={currentPage - 1}
          />

          {currentPage !== tableData.page_count ? (
            <li className={`page-data ${currentPage === tableData.page_count ? 'disabled' : ''}`}>
              <button className="btn btn-link page-link rounded-0" onClick={() => changePageNumber({ selected: tableData.page_count - 1 })}>
                Last <i className="bi bi-chevron-double-right"></i>
              </button>
            </li>
          ) : null}
          <li className="page-item">
            <input
              type="number"
              min={1}
              max={tableData.page_count}
              className="form-control page-link"
              style={{ width: "67px" }}
              placeholder="Page"
              value={pageSearch}
              onChange={(e) => setPageSearch(e.target.value)}
              onBlur={handlePageSearch}          // 👈 Fire on focus out
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.currentTarget.blur();        // 👈 Trigger blur = auto jump
                }
              }}
            />
          </li>
        </div>
      ) : null)}
      <ConfirmIndication
        isModalVisible={showCancelIndicationModal.isModalVisible}
        caseId={showCancelIndicationModal.caseId}
        prescriptionId={showCancelIndicationModal.prescriptionId}
        hideModal={() => {
          setDataForCancelIndication({
            isModalVisible: false,
            caseId: 0,
            prescriptionId: 0
          });
        }}
        refreshListing={() => redirectDecision()}
      />

      {saveNoteModal.isModalVisible ? (
        <AddNote
          isModalVisible={saveNoteModal.isModalVisible}
          caseId={saveNoteModal.caseId}
          refreshListing={() => isManufacturer ? onActionPerformed() : redirectDecision()}
          hideModal={() => {
            setDataforNoteModal({
              isModalVisible: false,
              caseId: 0,
            });
          }}
        />
      ) : null}

      {showRequestTreatmentModal.isModalVisible && (
        <RequestDateOfTreatment
          isModalVisible={showRequestTreatmentModal.isModalVisible}
          caseId={showRequestTreatmentModal.caseId}
          prescriptionId={showRequestTreatmentModal.prescriptionId}
          bentype={showRequestTreatmentModal.bentype}
          investigated_at={showRequestTreatmentModal.investigated_at}
          hideModal={() => {
            setDataForRequestModalTreatment({
              isModalVisible: false,
              caseId: 0,
              prescriptionId: 0,
              bentype: "",
              investigated_at: ""
            });
          }}
          refreshListing={() => redirectDecision()}
        />
      )}

      <CancelTreatment
        isModalVisible={cancelTreatmentModal.isModalVisible}
        caseId={cancelTreatmentModal.caseId}
        prescriptionId={cancelTreatmentModal.prescriptionId}
        hideModal={() => {
          setDataForCancelModal({
            isModalVisible: false,
            caseId: 0,
            prescriptionId: 0
          });
        }}
        refreshListing={() => redirectDecision()}
      />
      <ReRunPatientModal
        isModalVisible={showReRunPatientModal.isModalVisible}
        caseId={showReRunPatientModal.caseId}
        prescriptionId={showReRunPatientModal.prescriptionId}
        bentype={showReRunPatientModal.bentype}
        title={showReRunPatientModal.title}
        investigated_at={showReRunPatientModal.investigated_at}
        hideModal={() => {
          setShowReRunPatientModal({
            isModalVisible: false,
            caseId: 0,
            prescriptionId: 0,
            bentype: '',
            title: "",
            investigated_at: undefined
          });
        }}
        refreshListing={() => redirectDecision()}
      />
      <UploadClinicalModal
        caseId={precertInfoModal.caseId}
        precertId={precertInfoModal.precertId}
        isModalVisible={precertInfoModal.isModalVisible}
        hideModal={(shouldFetchAgain: boolean) => {
          if (shouldFetchAgain) {
            redirectDecision();
            // const action: ActionStatisticsDashboardActionType = {
            //   type: PatientFilterStateActions.CHANGE_TREATABLE_PAGE,
            //   payload: currentPage,
            // };
            // navigate(defaultView.includes("/") ? defaultView : `/${defaultView}`, { replace: true });
            // onPageChange(action as never)
          }
          setPrecertInfoModal({
            isModalVisible: false,
            caseId: 0,
            precertId: 0,
          })
        }}
      />
      <TransferCaseModal
        isModalVisible={transferCaseModal.isModalVisible}
        hideModal={() => {
          setTransferCaseModal({
            caseId: 0,
            precertId: 0,
            isModalVisible: false,
          })
          setTransferCaseNotnowModal(true)
        }}
        uploadClinicalInfo={() => {
          setPrecertInfoModal({
            isModalVisible: true,
            caseId: transferCaseModal.caseId,
            precertId: transferCaseModal.precertId,
          })
          setTransferCaseModal({
            caseId: 0,
            precertId: 0,
            isModalVisible: false,
          })
        }}
      />

      <TransferNotNowModal
        isModalVisible={transferCaseNotnowModal}
        hideModal={() => setTransferCaseNotnowModal(false)}
      />
    </Fragment>
  );
};

export default PendingTable;
